import React from 'react';
import { Sparkles } from 'lucide-react';
import './FeaturesHero.css';

export function FeaturesHero() {
  return (
    <section className="features-hero">
      <div className="features-hero__badge">
        <Sparkles size={15} />
        <span>AIMUS ALL-IN-ONE SOLUTION</span>
      </div>
      <h1 className="features-hero__title">
        데이터와 AI로 완성하는 <br />
        <span className="features-hero__title--gradient">스마트 양궁 솔루션</span>
      </h1>
      <p className="features-hero__desc">
        실시간 탄착군 기록부터 AI 3D 자세 교정 스켈레톤까지, 모든 궁사와 지도자를
        위한 가장 정밀한 분석 시스템을 경험해보세요.
      </p>
    </section>
  );
}
